import { UNIQUE_LINK_KEY } from '../constants'
import SimpleStore from '../utilities/SimpleStore'

declare const window

/**
 * Segment Analytics.js populates the UserID field through
 * cookies and local storage. Visiting a non-Dasher DoorDash
 * page can set this UserID to a value that is not the applicant
 * unique link, and when the user returns to the Dasher
 * Application funnel they will send events with the wrong UserID.
 *
 * This function will be used in Source Middleware to override
 * the Segment UserID in all event payloads to use the applicant
 * unique link when available in local storage.
 */
export const SMWUserID = ({ payload, next }) => {
  const uniqueLink = SimpleStore.get(UNIQUE_LINK_KEY)

  if (uniqueLink) {
    payload.obj.userId = uniqueLink
  }

  next(payload)
}

const addSourceMiddleware = () => {
  try {
    const middlewares = window.analytics._sourceMiddlewares.getMiddlewares()

    // Do not execute if middleware already exists
    if (!middlewares.find(middleware => middleware === SMWUserID)) {
      window.analytics.addSourceMiddleware(SMWUserID)
    }
  } catch (err) {
    console.error(err)
  }
}

export default addSourceMiddleware
